import { Component, OnInit, ViewChild } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { AutomaticallyPayFineRequest } from "../shared/AutomaticallyPayFineRequest";
import { AutomaticallyWaiveFineRequest } from "../shared/AutomaticallyWaiveFineRequest";
import { DataService_StudentFinesDebts } from "../shared/data.service";
import { ManualFineTableComponent } from "./manual-fine-table/manual-fine-table.component";
import { ManualUpdateModel } from "./ManualUpdateModel";
import { ManualUpdateRequest } from "./ManualUpdateRequest";
import * as moment from "moment";

@Component({
	selector: "app-student-pay-fine",
	templateUrl: "./student-pay-fine.component.html",
	styleUrls: ["./student-pay-fine.component.css"],
})
export class StudentPayFineComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private StudentFinesDebtsService: DataService_StudentFinesDebts
	) {}

	ngOnInit(): void {
		this.popup_WidthInt = window.innerWidth - 100;
		this.popup_Width = this.popup_WidthInt.toString() + "px;";

		this.user = this.dialogConfig.data.user;
		this.SelectedPerson = this.dialogConfig.data.SelectedPerson;
		this.CurrentBalance = this.dialogConfig.data.CurrentBalance;

		this.StudentID = this.SelectedPerson.DesignatorID;
		this.StudentName = this.SelectedPerson.PersonName;
		this.CurrentBalanceDesc = "$" + this.CurrentBalance;

		this.UpdatedBalance = this.dialogConfig.data.CurrentBalance;
		this.UpdatedBalanceDesc = "$" + this.UpdatedBalance;

		this.loadTenderTypes();
	}

	///////////////////////////////////////////////////
	// Data
	///////////////////////////////////////////////////

	@ViewChild(ManualFineTableComponent)
	ManualTableRef: ManualFineTableComponent;

	popup_WidthInt: any = 0;
	popup_Width: any = "";

	//From parent
	user: any;
	SelectedPerson: any;
	CurrentBalance: any;

	StudentID: any = "";
	StudentName: any = "";
	CurrentBalanceDesc: any = "";

	//Form
	Comments: any = "";

	MethodTypeID: any = 2;
	lstMethodType: any = [
		{
			ID: 2,
			Desc: "Automatically Pay Fines",
		},
		{
			ID: 3,
			Desc: "Automatically Waive Fines",
		},
		{
			ID: 1,
			Desc: "Manually Pay/Waive Fines",
		},
	];

	OrderID: any = 1;
	lstOrder: any = [
		{
			ID: 1,
			Desc: "Oldest First",
		},
		{
			ID: 2,
			Desc: "Newest First",
		},
	];

	TenderTypeID: any;
	lstTenderType: any = [];

	NewBalance: number = 0.0;
	NewBalanceDesc: string = "$0.00";

	TotalPaid: number = 0.0;
	TotalPaidDesc: string = "$0.00";

	TotalWaived: number = 0.0;
	TotalWaivedDesc: string = "$0.00";

	PaidAmount: number = 0;
	UpdatedBalance: number = 0;
	UpdatedBalanceDesc: string = "$0.00";

	errorMessage: any = "";

	///////////////////////////////////////////////////

	///////////////////////////////////////////////////
	// Load Data
	///////////////////////////////////////////////////
	loadTenderTypes() {
		var result = this.StudentFinesDebtsService.TenderTypeGetList();
		result.subscribe(
			(response) => {
				this.lstTenderType = response;

				this.TenderTypeID = this.lstTenderType[0].TenderTypeID;
			},
			(error) => {}
		);
	}

	///////////////////////////////////////////////////

	///////////////////////////////////////////////////
	// Buttons
	///////////////////////////////////////////////////
	onUpdate() {
		this.errorMessage = "";

		if (Number(this.PaidAmount) < 0) {
			this.errorMessage = "Payment amount must be > 0";
			return;
		}
		if (Number(this.PaidAmount) > this.CurrentBalance) {
			this.errorMessage = "Payment amount must be < " + this.CurrentBalance;
			return;
		}

		//Check type of update

		//Manual
		if (this.MethodTypeID == 1) {
			this.ManualPay();
		}
		//Auto pay
		else if (this.MethodTypeID == 2) {
			this.AutoPay();
		}
		//Auto waive
		else if (this.MethodTypeID == 3) {
			this.AutoWaive();
		}
	}

	ManualPay() {
		//Create list of values being changed

		// let lstManualUpdates: ManualUpdateModel[] = [];

		let FineIDs: number[] = [];
		let lstPaid: string[] = [];
		let lstWaived: string[] = [];

		for (var i = 0; i < this.ManualTableRef.lstFine.length; i++) {
			var next = this.ManualTableRef.lstFine[i];

			if (next.Paid > 0 || next.Waived > 0) {
				// let NextEntry: ManualUpdateModel = {
				//   FineID: next.FineID,
				//   PaidAmount: next.Paid,
				//   WaivedAmount: next.Waived
				// }

				// lstManualUpdates = [...lstManualUpdates, NextEntry];

				FineIDs = [...FineIDs, next.FineID];
				lstPaid = [...lstPaid, Number(next.Paid).toFixed(2)];
				lstWaived = [...lstWaived, Number(next.Waived).toFixed(2)];
			}
		}

		let UpdateRequest: ManualUpdateRequest = {
			PersonID: this.SelectedPerson.PersonID,
			AdminID: this.user.personID,
			AppliedDT: moment(new Date()).format("MM/DD/YYYY HH:mm:00"),
			AppliedComment: this.Comments,
			SchoolID: this.SelectedPerson.SchoolID,
			TenderTypeID: this.TenderTypeID,

			// lstUpdates: lstManualUpdates

			lstFineIDs: FineIDs,
			lstPaid: lstPaid,
			lstWaived: lstWaived,
		};

		//Call SP

		var result = this.StudentFinesDebtsService.ManuallyPayWaive(UpdateRequest);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "pay",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Fines were updated successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "pay",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not updated Fine(s)",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	AutoPay() {
		//Error handling
		if (this.PaidAmount == 0) {
			this.errorMessage = "Amount must be > 0";
			return;
		} else if (this.PaidAmount > this.CurrentBalance) {
			this.errorMessage = "Amount must be <= " + this.CurrentBalanceDesc;
			return;
		}

		let parms: AutomaticallyPayFineRequest = {
			PersonID: this.SelectedPerson.PersonID,
			Administrator_PersonID: this.user.personID,
			TenderTypeID: this.TenderTypeID,
			AccountCreditDT: moment(new Date()).format("MM/DD/YYYY HH:mm:00"),
			AccountCreditAmount: this.PaidAmount.toFixed(2),
			AccountCreditBalance: this.CurrentBalance,
			AccountCreditComment: this.Comments,
			SchoolID: this.SelectedPerson.SchoolID,
			OrderBy: this.OrderID,
		};

		//Call SP
		var result = this.StudentFinesDebtsService.AutomaticallyPayFine(parms);
		result.subscribe(
			(response: any) => {
				if (response.IsError == false) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "pay",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Fines were paid successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "pay",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not pay Fine(s): " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	AutoWaive() {
		//Error handling
		if (this.PaidAmount == 0) {
			this.errorMessage = "Amount must be > 0";
			return;
		} else if (this.PaidAmount > this.CurrentBalance) {
			this.errorMessage = "Amount must be <= " + this.CurrentBalanceDesc;
			return;
		}

		let parms: AutomaticallyWaiveFineRequest = {
			PersonID: this.SelectedPerson.PersonID,
			Administrator_PersonID: this.user.personID,
			AccountCreditDT: moment(new Date()).format("MM/DD/YYYY HH:mm:00"),
			AccountCreditAmount: this.PaidAmount.toString(),
			AccountCreditBalance: this.CurrentBalance,
			AccountCreditComment: this.Comments,
			SchoolID: this.SelectedPerson.SchoolID,
			OrderBy: this.OrderID,
		};

		//Call SP
		var result = this.StudentFinesDebtsService.AutomaticallyWaiveFine(parms);
		result.subscribe(
			(response: any) => {
				if (response.IsError == false) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "pay",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Fines were waived successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "pay",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not waive Fine(s): " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onClose() {
		this.ref.close(0);
	}

	///////////////////////////////////////////////////

	///////////////////////////////////////////////////
	// Events
	///////////////////////////////////////////////////

	onManualDataChange() {
		this.NewBalance = 0;
		this.TotalPaid = 0;
		this.TotalWaived = 0;

		for (var i = 0; i < this.ManualTableRef.lstFine.length; i++) {
			var next = this.ManualTableRef.lstFine[i];

			this.NewBalance += next.Balance;
			this.TotalPaid += next.Paid;
			this.TotalWaived += next.Waived;
		}

		this.NewBalanceDesc = "$" + Number(this.NewBalance).toFixed(2);
		this.TotalPaidDesc = "$" + Number(this.TotalPaid).toFixed(2);
		this.TotalWaivedDesc = "$" + Number(this.TotalWaived).toFixed(2);
	}

	onMethodTypeChange(val) {
		//Do you want to reset fine amount?
		this.TenderTypeID = this.lstTenderType[0].TenderTypeID;

		if (val == 1) {
			this.onPaidAmountChange(0);
		}

		this.MethodTypeID = val;
	}

	onPaidAmountChange(val) {
		this.PaidAmount = val;

		//
		// If > Max set to max
		//
		if (Number(Number(this.PaidAmount).toFixed(2)) > this.CurrentBalance) {
			this.PaidAmount = this.CurrentBalance;
		}

		//Update Balance

		this.UpdatedBalance = this.CurrentBalance - this.PaidAmount;
		this.UpdatedBalanceDesc = "$" + Number(this.UpdatedBalance).toFixed(2);
	}

	///////////////////////////////////////////////////
}
